import { render, staticRenderFns } from "./Mkb10.vue?vue&type=template&id=e8d3d7b2&"
import script from "./Mkb10.vue?vue&type=script&lang=js&"
export * from "./Mkb10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports